module.exports = __webpack_public_path__ + "img/to.f4d05f56.svg";